export const GET_CURRENCY_SUCCESS = 'GET_CURRENCY_SUCCESS'
export const GET_CURRENCY_ERROR = 'GET_CURRENCY_ERROR'
export const ABLE_BUTTON = 'ABLE_BUTTON'
export const DISABLE_BUTTON = 'DISABLE_BUTTON'
export const GET_DOLAR = 'GET_DOLAR'
export const GET_FEE = 'GET_FEE'
export const CASH_SELECTED = 'CASH_SELECTED'
export const CARD_SELECTED = 'CARD_SELECTED'
export const CALCULATE_EXCHANGE = 'CALCULATE_EXCHANGE'
export const CLEAR_STATES = 'CLEAR_STATES'
export const CHECK_FORM = 'CHECK_FORM'
export const SHOW_ALERT = 'SHOW_ALERT'
